import { ancillaryLabWorkflow } from '@ldt/workflows/ancillary_lab';
import { clinicWorkflow } from '@ldt/workflows/clinic';
import { directUploadLabWorkflow } from '@ldt/workflows/direct_upload_lab';
import { tempusWorkflow } from '@ldt/workflows/tempus';
import type { LdtWorkflowDefinition } from '@ldt/workflows/types';
import { WorkflowType } from 'src/types/workflows';

const registry: Partial<Record<WorkflowType, LdtWorkflowDefinition>> = {
  [WorkflowType.CLINIC]: clinicWorkflow,
  [WorkflowType.ANCILLARY_LAB]: ancillaryLabWorkflow,
  [WorkflowType.DIRECT_UPLOAD_LAB]: directUploadLabWorkflow,
  [WorkflowType.TEMPUS]: tempusWorkflow,
};

/**
 * Returns the LDT workflow definition for a workflow type.
 * Use this instead of branching on workflowType or calling status_filters/order_actions directly.
 */
export function getLdtWorkflowDefinition(
  workflowType: WorkflowType,
): LdtWorkflowDefinition {
  const definition = registry[workflowType];
  if (!definition) {
    throw new Error(`No LDT workflow definition for: ${workflowType}`);
  }

  return definition;
}
